import React, { useState } from 'react';
import LinkPreview from './components/LinkPreview';
import './components/LinkPreview.css';
import './App.css';

function App() {
  const [url, setUrl] = useState('');
  const [inputUrl, setInputUrl] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setUrl(inputUrl);
  };

  return (
    <div className="App">
      <h1>海淘网页预览工具</h1>
      
      <form onSubmit={handleSubmit} className="url-form">
        <input
          type="url"
          value={inputUrl}
          onChange={(e) => setInputUrl(e.target.value)}
          placeholder="输入网址 (例如: https://example.com)"
          required
          className="url-input"
        />
        <button type="submit" className="submit-button">生成预览</button>
      </form>
      
      {url && <LinkPreview url={url} />}
    </div>
  );
}

export default App;